import { ROUTES } from ".";

export const MANAGE_TRADE_ROUTES = {
  TRANSACTION_VIEW: `${ROUTES.TRADE}/transaction-view`,
  INVESTMENT_VIEW: `${ROUTES.TRADE}/investment-view`,
  TRADE_ORDER_INSTRUCTION: `${ROUTES.TRADE}/trade-order-instruction`,
  TRADE_ORDER_RECONCILATION: `${ROUTES.TRADE}/trade-order-reconcilation`,
  TRANSACTION_VIEW_DETAILS: `${ROUTES.TRADE}/transaction-view-details`,
  TRADE_ORDER_INVESTMENT: `${ROUTES.TRADE}/trade-order-investment`,
};

export const REVIEW_SCREEN_DATA_MAPPING = {
  TRANSACTION_VIEW: `transactionView`,
  INVESTMENT_VIEW: `investmentView`,
  TRADE_ORDER_INSTRUCTION: `tradeOrderInstruction`,
  TRADE_ORDER_RECONCILATION: `tradeOrderReconcilation`,
  TRANSACTION_VIEW_DETAILS: `transactionViewDetails`,
  TRADE_ORDER_INVESTMENT: `tradeOrderInvestment`,
};

export const MANAGE_TRADE_MENU = [
  // {
  //   label: "Trade Process",
  //   subNav: [
  //     {
  //       id: REVIEW_SCREEN_DATA_MAPPING.TRANSACTION_VIEW,
  //       label: "Transaction View",
  //       path: MANAGE_TRADE_ROUTES.TRANSACTION_VIEW,
  //       contentHeader: "Trade",
  //       breadCrumbs: [],
  //       childRoutes: [],
  //     },
  //     {
  //       id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENT_VIEW,
  //       label: "Investment View",
  //       path: MANAGE_TRADE_ROUTES.INVESTMENT_VIEW,
  //       contentHeader: "Trade",
  //       breadCrumbs: [],
  //       childRoutes: [],
  //     },

  //   ],
  //   breadCrumbs: [],
  //   childRoutes: [],
  // },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRANSACTION_VIEW,
    label: "Transaction View",
    path: MANAGE_TRADE_ROUTES.TRANSACTION_VIEW,
    contentHeader: "Transaction View",
    breadCrumbs: [],
    childRoutes: [
      {
        id: REVIEW_SCREEN_DATA_MAPPING.TRANSACTION_VIEW_DETAILS,
        label: "Transaction View Details",
        path: MANAGE_TRADE_ROUTES.TRANSACTION_VIEW_DETAILS,
        contentHeader: "Transaction View Details",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENT_VIEW,
    label: "Investment View",
    path: MANAGE_TRADE_ROUTES.INVESTMENT_VIEW,
    contentHeader: "Investment View",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRADE_ORDER_INSTRUCTION,
    label: "Trade Order Instruction",
    path: MANAGE_TRADE_ROUTES.TRADE_ORDER_INSTRUCTION,
    contentHeader: "Trade Order Instruction",
    breadCrumbs: [],
    childRoutes: [
      {
        id: REVIEW_SCREEN_DATA_MAPPING.TRADE_ORDER_INVESTMENT,
        label: "Trade Order Investment",
        path: MANAGE_TRADE_ROUTES.TRADE_ORDER_INVESTMENT,
        contentHeader: "Trade Order Investment",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRADE_ORDER_RECONCILATION,
    label: "Trade Order Reconcilation",
    path: MANAGE_TRADE_ROUTES.TRADE_ORDER_RECONCILATION,
    contentHeader: "Trade Order Reconcilation",
    breadCrumbs: [],
    childRoutes: [],
  },
];

export const ALL_MANAGE_TRADE_ROUTES = [
  ...MANAGE_TRADE_MENU,
  // {
  //   id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENT,
  //   contentHeader: "Investment",
  //   path: MANAGE_TRADE_ROUTES.ADD_INVESTMENT,
  //   breadCrumbs: [
  //     {
  //       label: "Manage Investments",
  //       link: MANAGE_TRADE_ROUTES.INVESTMENT,
  //     },
  //   ],
  // },
  // {
  //   id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
  //   contentHeader: "Custodian",
  //   path: MANAGE_TRADE_ROUTES.ADD_CUSTODIAN,
  //   breadCrumbs: [
  //     {
  //       label: "Manage Custodians",
  //       link: MANAGE_TRADE_ROUTES.CUSTODIAN,
  //     },
  //   ],
  // },
  // {
  //   id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
  //   contentHeader: "Custodian",
  //   path: MANAGE_TRADE_ROUTES.CUSTODIAN_DETAIL,
  //   breadCrumbs: [
  //     {
  //       label: "Manage Custodians",
  //       link: MANAGE_TRADE_ROUTES.CUSTODIAN,
  //     },
  //   ],
  // },
];

export const manageTradeFormNames = {
  TRANSACTION_VIEW: `transaction-view`,
  INVESTMENT_VIEW: `investment-view`,
  TRADE_ORDER_INSTRUCTION: `trade-order-instruction`,
  TRADE_ORDER_RECONCILATION: `trade-order-reconcilation`,
};

export const tradeFormFields = {
  [manageTradeFormNames.TRANSACTION_VIEW]: {
    search: "search",
    transactionType: "transactionType",
    tradeStatus: "tradeStatus",
    fromDate: "fromDate",
    toDate: "toDate",
  },
  [manageTradeFormNames.INVESTMENT_VIEW]: {
    search: "search",
    investmentType: "investmentType",
    investmentStatus: "investmentStatus",
  },
  [manageTradeFormNames.TRADE_ORDER_INSTRUCTION]: {
    fromDate: "fromDate",
    toDate: "toDate",
  },
  [manageTradeFormNames.TRADE_ORDER_RECONCILATION]: {},
};

export const INVESTMENT_RECORDS_TO_FETCH = 20;
